module.exports = __webpack_public_path__ + "static/media/remove.86fecc2d.svg";